module.exports = __webpack_public_path__ + "img/krzyz.58ea590b.jpg";